import { TruongService } from "../services/truong.service";

var state = {
	tinhs: [],
	truonglop10: [],
	truonglop11: [],
	truonglop12: [],
	thongtinlop10: { truongId: "", tinhId: "" },
	thongtinlop11: { truongId: "", tinhId: "" },
	thongtinlop12: { truongId: "", tinhId: "" },
};

var getters = {
	thongtinlop10: (state) => state.thongtinlop10,
	thongtinlop11: (state) => state.thongtinlop11,
	thongtinlop12: (state) => state.thongtinlop12,
};

var mutations = {
	updateLop10(state, data) {
		state.truonglop10 = data;
	},

	updateLop11(state, data) {
		state.truonglop11 = data;
	},

	updateLop12(state, data) {
		state.truonglop12 = data;
	},

	updatethongtinlop10(state, data) {
		state.thongtinlop10 = data;
	},

	updatethongtinlop11(state, data) {
		state.thongtinlop11 = data;
	},

	updatethongtinlop12(state, data) {
		state.thongtinlop12 = data;
	},

	getTinhs(state, data) {
		state.tinhs = data;
	},

	loadNew(state) {
		state.thongtinlop10 = { truongId: "", tinhId: "" };
		state.thongtinlop11 = { truongId: "", tinhId: "" };
		state.thongtinlop12 = { truongId: "", tinhId: "" };
	},
};

var actions = {
	getTruongByMaTinh({ commit }, { matinh, lop }) {
		return TruongService.getTruongByMaTinh(matinh)
			.then((response) => {
				if (response.status === 200) {
					switch (lop) {
						case 10:
							commit("updateLop10", response.data);
							break;
						case 11:
							commit("updateLop11", response.data);
							break;
						case 12:
							commit("updateLop12", response.data);
							break;
					}
				}
				return response;
			})
			.catch((err) => err.message);
	},

	getTinhsTruongId({ commit, dispatch }, { truongId, lop }) {
		return TruongService.getTruongById(truongId)
			.then((response) => {
				if (response.status === 200) {
					let data = {
						truongId: truongId,
						tinhId: response.data.maTinh,
					};
					switch (lop) {
						case 10:
							commit("updatethongtinlop10", data);
							break;
						case 11:
							commit("updatethongtinlop11", data);
							break;
						case 12:
							commit("updatethongtinlop12", data);
							break;
					}
					dispatch("getTruongByMaTinh", {
						matinh: response.data.maTinh,
						lop: lop,
					});
				}
				return response;
			})
			.catch((error) => error.message);
	},

	getTinhs({ commit }) {
		return TruongService.getTinhs()
			.then((response) => {
				if (response.status === 200) commit("getTinhs", response.data);
				return response;
			})
			.catch((error) => error.message);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
